// extracted by mini-css-extract-plugin
export var fadeInOut = "_2w-3";
export var icon = "_2w-4";
export var savedIndicator = "_2w-2";
export var savingIndicator = "_2w-0";
export var spin = "_2w-1";